<template>
  <div class="my-2">
    <span v-bind="oAtributos" class="text-medium text-primary font-size-1">{{ titulo }}</span>
  </div>
</template>

<script>
import FormMixin from '@/mixins/formularioMixin.js'

export default {
  name: 'FormLabel',
  mixins: [FormMixin],
  props: {
    oAtributos:{
      type:Object,
      default:()=>{}
    }
  },
  data() {
    return {}
  },
}
</script>